import React from 'react'
import { Accordion, Card } from 'react-bootstrap'
import AccordionToggle from './accordionToggle'

const AccordionCard = ({
  title,
  children,
  defaultActive,
  className,
  expandAccordion,  
}) => (
  <Accordion
    as={Card}
    defaultActiveKey={
      expandAccordion ? expandAccordion : defaultActive ? '0' : null
    }
    className={`flex-column-reverse ${className}`}
  >
    <Accordion.Collapse
      eventKey="0"
      className="rounded-bottom expandAccordion"
    >
      <Card.Body>{children}</Card.Body>
    </Accordion.Collapse>
    <AccordionToggle
      readerText={title}
      eventKey="0"
      defaultActive={
        expandAccordion ? expandAccordion : defaultActive ? '0' : null
      }
      as={Card.Header}
      expandAccordion={expandAccordion}
    >
      {title}
    </AccordionToggle>
  </Accordion>
)

export default AccordionCard
